import request from 'crm/utils/request'
import api from 'crm/common/api/lost-customer'

export async function search(params) {
    return request(api.search.url, {
        method: api.search.type,
        body: params,
    })
}

export async function exportTaskId(payload) {
    return request(api.exportTaskId.url, {
        method: api.exportTaskId.type,
        body: payload.body,
    })
}
